import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["as", "margin", "elementRef"];
var _dec, _class, _InlineList;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Children, Component } from 'react';
import { View } from '@instructure/ui-view';
import { passthroughProps, safeCloneElement } from '@instructure/ui-react-utils';
import { testable } from '@instructure/ui-testable';
import { InlineListItem } from './InlineListItem';
import { propTypes, allowedProps } from './props';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
---
category: components
---

**/
let InlineList = (_dec = testable(), _dec(_class = (_InlineList = class InlineList extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  renderChildren() {
    const childrenArray = Children.toArray(this.props.children);
    const lastIndex = childrenArray.length - 1;
    return childrenArray.map((child, index) => {
      if (!child) return null;
      const shouldRenderPlaceholder = index === lastIndex;
      return safeCloneElement(child, {
        delimiter: this.props.delimiter,
        size: this.props.size,
        spacing: this.props.itemSpacing,
        lastPlaceholder: shouldRenderPlaceholder
      });
    });
  }
  render() {
    const _this$props = this.props,
      as = _this$props.as,
      margin = _this$props.margin,
      elementRef = _this$props.elementRef,
      rest = _objectWithoutProperties(_this$props, _excluded);
    return _jsx(View, {
      ...passthroughProps(rest),
      as: as,
      margin: margin,
      padding: "0",
      elementRef: this.handleRef,
      display: "block",
      children: this.renderChildren()
    });
  }
}, _InlineList.displayName = "InlineList", _InlineList.propTypes = propTypes, _InlineList.allowedProps = allowedProps, _InlineList.defaultProps = {
  itemSpacing: 'none',
  as: 'ul',
  margin: 'none',
  delimiter: 'none',
  size: 'medium'
}, _InlineList.Item = InlineListItem, _InlineList)) || _class);
export default InlineList;
export { InlineList };